import { render, staticRenderFns } from "./orderMonthlyChartWidget.vue?vue&type=template&id=fc19c838&"
import script from "./orderMonthlyChartWidget.vue?vue&type=script&lang=js&"
export * from "./orderMonthlyChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports